import { render } from "./school-meals-incremental-field.vue?vue&type=template&id=b6af0bec"
import script from "./school-meals-incremental-field.vue?vue&type=script&lang=js"
export * from "./school-meals-incremental-field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__